/*

  Faux Dialog

  Appears like a dialog without the header, with no open/close.
  Only use if there is no important content or functionality in the page.

  No functionality apart from rendering the template and enabling global styles.

*/
import { addGlobalStylesToShadowRoot } from 'MusicV3/v3/custom_elements/shared/utils/custom_elements.js';
import styles from './_faux_dialog.scss?inline';

/**
 * Faux Dialog class.
 */
export default class UaFauxDialog extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  /**
   * Component template
   * @return {String} - The HTML to be inserted into the document.
   */
  template() {
    return `
      <div class="faux-dialog-wrapper">
        <div class="ua-panel">
          <div class="ua-panel__body  c-scrollbar-v3  c-scrollbar-v3--fade-effect  js-scrollbar-prevent-submit">
            <slot></slot>
          </div>
          <footer class="ua-panel__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
      <style>
      ${styles}
      </style>
    `;
  }

  /** Render the component */
  render() {
    this.shadowRoot.innerHTML = `
      ${this.template()}
    `;
  }

  /**
   * Render the initial state.
   */
  connectedCallback() {
    addGlobalStylesToShadowRoot(this.shadowRoot);
    this.render();
  }
}
